module.exports = __webpack_public_path__ + "static/media/gmail_full_logo.f0ef8ecf.jpg";